import { InsurancePolicyType } from "@wingspanhq/wingspan-api-sdk";

import { selectorPlanTypeDetails } from "../../Benefits/selectors/selectorPlanTypeDetails";
import {
  OAI_KEY,
  PGLI_KEY,
  WingspanPlanTypes
} from "../../Benefits/utils/constants";

/**
 * The Wingspan insurance product, if any, that covers one of the requested
 * policy types. SDK 3.13.0's `InsurancePolicyType` restored the
 * `OccupationalAccident` member that the previous `CoverageType` enum lacked,
 * so the occupational-accident product is detectable again.
 */
export const selectorMasterPolicyNameByPolicyType = (
  // wire values — accepts both the v1 settings policy types and v3 InsurancePolicyType
  policyTypes: (InsurancePolicyType | string)[] | undefined
) => {
  let wingspanPlanType: WingspanPlanTypes | undefined;

  if (policyTypes?.includes(InsurancePolicyType.OCCUPATIONAL_ACCIDENT)) {
    wingspanPlanType = OAI_KEY;
  } else if (
    policyTypes?.includes(InsurancePolicyType.PROFESSIONAL_LIABILITY) ||
    policyTypes?.includes(InsurancePolicyType.GENERAL_LIABILITY)
  ) {
    wingspanPlanType = PGLI_KEY;
  }

  if (wingspanPlanType) {
    const planDetails = selectorPlanTypeDetails(wingspanPlanType);

    return planDetails.shortName;
  }

  return undefined;
};
